export const GET_LINKS = 'GET_LINKS';
export const GET_LINKS_SUCCESS = 'GET_LINKS_SUCCESS';
export const GET_LINKS_ERROR = 'GET_LINKS_ERROR';

export const GET_LINK = 'GET_LINK';
export const GET_LINK_SUCCESS = 'GET_LINK_SUCCESS';
export const GET_LINK_ERROR = 'GET_LINK_ERROR';

export const SAVE_LINK = 'SAVE_LINK';
export const SAVE_LINK_SUCCESS = 'SAVE_LINK_SUCCESS';
export const SAVE_LINK_ERROR = 'SAVE_LINK_ERROR';

// export const UPDATE_AGM_PRESENCE = 'UPDATE_AGM_PRESENCE';
// export const UPDATE_AGM_PRESENCE_SUCCESS = 'UPDATE_AGM_PRESENCE_SUCCESS';
// export const UPDATE_AGM_PRESENCE_ERROR = 'UPDATE_AGM_PRESENCE_ERROR';

export const DELETE_LINK = 'DELETE_LINK';
export const DELETE_LINK_SUCCESS = 'DELETE_LINK_SUCCESS';
export const DELETE_LINK_ERROR = 'DELETE_LINK_ERROR';
export const SET_LINK_ENABLED = 'SET_LINK_ENABLED';

export const CLEAR_LINKS = 'CLEAR_LINKS';
export const CLEAR_LINK = 'CLEAR_LINK';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Links/constants.js